import React from "react";
import PolicyPageLayout, { PolicyList, PolicySection } from "./PolicyPageLayout";
import { COMPANY_DETAILS } from "./policyData";

const ReturnPolicy = () => {
  return (
    <PolicyPageLayout
      title="Return Policy"
      subtitle="We aim to keep returns fair and transparent. This policy applies to eligible physical products purchased through our website."
    >
      <PolicySection title="1. Applicability">
        <p>
          This policy applies to eligible physical products sold by{" "}
          {COMPANY_DETAILS.name}. It does not automatically apply to repair
          services, custom orders, software items or items specifically marked
          as non-returnable.
        </p>
      </PolicySection>

      <PolicySection title="2. Return Eligibility Window">
        <p>
          Return requests must be raised within 5 calendar days from the date
          of delivery. Requests raised after this period may not be eligible for
          return, replacement or refund unless covered separately under a valid
          warranty commitment.
        </p>
      </PolicySection>

      <PolicySection title="3. Eligible Return Reasons">
        <PolicyList
          items={[
            "Wrong product delivered.",
            "Product received in physically damaged condition.",
            "Product is dead on arrival or materially defective on first use.",
            "Product received is materially different from what was ordered or described.",
          ]}
        />
      </PolicySection>

      <PolicySection title="4. Conditions for Accepting a Return">
        <PolicyList
          items={[
            "The item should be returned with invoice or order proof.",
            "Original accessories, packaging, tags, manuals and bundled items should be included wherever applicable.",
            "The product must not show signs of misuse, accidental damage, liquid damage, unauthorised repair or tampering after delivery.",
            "For transit damage or missing-item claims, we may ask for package photos, label photos and unboxing evidence where available.",
          ]}
        />
      </PolicySection>

      <PolicySection title="5. Non-Returnable Situations">
        <PolicyList
          items={[
            "Software licenses, digital items or activation-based products.",
            "Items damaged after delivery because of user mishandling, electrical damage, liquid exposure or unauthorised servicing.",
            "Custom-configured, specially procured or clearly marked non-returnable items.",
            "Consumables, accessories or bundled promotional items unless defective on arrival.",
            "Requests based only on change of mind after the item has been accepted and used.",
          ]}
        />
      </PolicySection>

      <PolicySection title="6. Inspection and Return Approval">
        <p>
          Every returned item is subject to inspection and verification. After
          successful inspection, we may approve a replacement, repair, store
          adjustment or refund, depending on stock availability, product
          condition and the nature of the issue.
        </p>
      </PolicySection>

      <PolicySection title="7. Return Pickup or Self-Shipping">
        <p>
          Depending on the item, destination and courier availability, we may
          arrange reverse pickup or ask you to self-ship the item to an address
          provided by our support team. Return logistics instructions will be
          shared only after preliminary approval.
        </p>
      </PolicySection>

      <PolicySection title="8. How to Raise a Return Request">
        <p>
          Please contact our support team with your order ID, issue details and
          clear photos or videos of the item if requested. We may guide you
          through troubleshooting before approving a return pickup or drop-off.
        </p>
      </PolicySection>

      <PolicySection title="9. Contact for Return Requests">
        <p>
          Return requests can be raised by phone or email at {COMPANY_DETAILS.phone}{" "}
          or {COMPANY_DETAILS.email} during {COMPANY_DETAILS.supportHours}.
        </p>
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default ReturnPolicy;
